// src/screens/admin/settings/AdminSetting.js
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { FiPercent, FiSave, FiInfo } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminMasterLayout from "../../../layouts/admin/AdminMasterLayout";
import MyContext from "../../../contexts/AppContext";
import "../../../assets/css/admin/screens/settings/AdminSetting.css";

const AdminSettingsManagement = () => {
  const { baseUrl, adminAuthToken } = useContext(MyContext);

  // Commission state
  const [commissionRate, setCommissionRate]   = useState("");
  const [effectiveDate, setEffectiveDate]     = useState("");
  const [commissionSaved, setCommissionSaved] = useState(false);

  // ── view existing commission ────────────────────────────────────────────
  const viewCommission = () => {
    axios
      .get(`${baseUrl}/admin/commission/viewCommission` ,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${adminAuthToken}`,
          },
      })
      .then((response) => {
        const commission = response.data.commission;
        if (commission) {
          setCommissionRate(commission.commission_percentage);
          setEffectiveDate(commission.effective_date);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // ── save commission ─────────────────────────────────────────────────────
  const handleCommissionSave = () => {
    if (!commissionRate || !effectiveDate) return;

    const loggedInAdmin = JSON.parse(localStorage.getItem("loggedInAdmin"));
    const chadminId = loggedInAdmin?.id;

    const formdata = new FormData();
    formdata.append("commission_percentage", commissionRate);
    formdata.append("effective_date", effectiveDate);
    formdata.append("chadmin_id", chadminId);

    axios
      .post(`${baseUrl}/admin/commission/saveCommission`, formdata, {
        headers: { "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
         },
      })
      .then((response) => {
        toast.success(response.data.msg || "Commission Saved");
        setCommissionSaved(true);
        setTimeout(() => setCommissionSaved(false), 3000);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Something went wrong. Please try again.");
      });
  };

  useEffect(() => {
    viewCommission();
  }, []);

  return (
    <AdminMasterLayout>
      <div className="st-shell">

        {/* Page Header */}
        <div className="st-header">
          <h2 className="st-page-title">Platform Settings</h2>
          <p className="st-page-sub">Manage commission rates for your platform.</p>
        </div>

        <div className="st-grid">

          {/* Commission Card */}
          <div className="st-card">
            <div className="st-card-head">
              <div className="st-card-icon st-icon-green">
                <FiPercent />
              </div>
              <div>
                <h4 className="st-card-title">Commission Management</h4>
                <p className="st-card-sub">Set the platform's cut on every sale</p>
              </div>
            </div>

            <div className="st-card-body">
              <div className="st-field">
                <label className="st-label">Commission Rate</label>
                <div className="st-input-addon">
                  <input
                    type="number"
                    className="st-input"
                    placeholder="e.g. 10"
                    min="0"
                    max="100"
                    value={commissionRate}
                    onChange={e => setCommissionRate(e.target.value)}
                  />
                  <span className="st-addon">%</span>
                </div>
              </div>

              <div className="st-field">
                <label className="st-label">Effective Date</label>
                <input
                  type="date"
                  className="st-input"
                  value={effectiveDate}
                  onChange={e => setEffectiveDate(e.target.value)}
                />
              </div>

              <div className="st-info-row">
                <FiInfo className="st-info-icon" />
                <p className="st-info-text">
                  Changes apply to all new orders placed after the effective date.
                </p>
              </div>

              <button
                className={`st-btn st-btn-green ${commissionSaved ? "st-btn-saved" : ""}`}
                onClick={handleCommissionSave}
                disabled={!commissionRate || !effectiveDate}
              >
                <FiSave />
                {commissionSaved ? "Saved!" : "Save Commission"}
              </button>
            </div>
          </div>

        </div>
      </div>
      <ToastContainer />
    </AdminMasterLayout>
  );
};

export default AdminSettingsManagement;